import React, { useCallback, useState } from "react";


import {ILabel, Label} from "./Label"

export const InputText : React.FC<Props> = (props : Props) : JSX.Element => {



  let [value, setValue] = useState(props.value === undefined ? "" : props.value);
  const onChange = useCallback((event) => { setValue(event.value); }, [value]);

    return (

        <div className="input-container">
        { props.label === undefined ?
          null : 
          <Label
          label = {props.label}
          isRequired = {props.isRequired}
          />
        }
        <input
          onChange={props.onChange === undefined ? onChange : props.onChange}
          onBlur={props.onBlur}
          placeholder={props.placeholder}
          name={props.name}
          id={props.name}
          value={props.onChange === undefined ? value : props.value}
        />
      </div>

  );    

};


export const InputPassword : React.FC<Props> = (props : Props) : JSX.Element => {



  let [value, setValue] = useState(props.value === undefined ? "" : props.value);
  let [isMasked, setIsMasked] = useState(true);

  const onTogglePassword = useCallback((event)=>{setIsMasked(!isMasked)},[isMasked])
  const onChange = useCallback((event) => { setValue(event.value); }, [value]);

    return (

        <div className="input-container">
        { props.label === undefined ?
          null : 
          <Label
          label = {props.label}
          isRequired = {props.isRequired}
          />
        }
        <input
          onChange={props.onChange === undefined ? onChange : props.onChange}
          onBlur={props.onBlur}
          placeholder={props.placeholder}
          name={props.name}
          id={props.name}
          value={props.onChange === undefined ? value : props.value}
          type={isMasked ? "password" : ""}
        />
        <span className={isMasked ? "icon eye password" : "icon eye" } onClick={onTogglePassword}><i className="fas fa-eye"></i></span>
      </div>

  );    

};


interface Props {
    readonly label : ILabel | undefined;
    readonly isRequired : boolean | undefined;
    readonly onBlur : React.FocusEventHandler<HTMLInputElement> | undefined;
    readonly onChange : React.ChangeEventHandler<HTMLInputElement> | undefined;
    readonly placeholder : string | undefined;
    readonly name : string | undefined;
    readonly value : string | undefined;
}